import { useState } from 'react'
import { formatNumberAsThousands } from 'utils/priceHelpers'

import CampaignConversionResults from './CampaignConversionResults'
import { campaignNames, colors } from './constants'
import { ReactComponent as LinkNewTabIcon } from './linkNewTab.svg'
import styles from './SegmentsChart.module.scss'

const minWidth = 25
const maxWidth = 120

function getBarWidth(percentage) {
  return ((minWidth + percentage) * maxWidth * 1.1) / 100
}

const SegmentsChart = ({
  barData,
  fromDate,
  toDate,
  showAllHotels,
  showWholeGroup,
  hasConversionResults = false
}) => {
  const [activeSegment, setActiveSegment] = useState(null)

  const isClickable = !showAllHotels && !showWholeGroup && hasConversionResults

  return (
    <>
      {activeSegment ? (
        <CampaignConversionResults
          category={activeSegment}
          onClose={() => setActiveSegment(null)}
          fromDate={fromDate}
          toDate={toDate}
          kind="CurrentSubsidiary"
          segment={activeSegment}
        />
      ) : null}
      <div className={styles.bars}>
        {barData
          .filter(c => c.count > 0)
          .map((campaign, index) => (
            <div
              className={isClickable ? styles.barHolder : styles.barHolderAll}
              key={index}
              onClick={isClickable ? () => setActiveSegment(campaign.name) : null}
            >
              <div
                className={styles.bar}
                style={{
                  backgroundColor: colors[index] || '#ccc',
                  width: `${getBarWidth(campaign.percentage)}%`
                }}
              >
                {campaignNames[campaign.name] || campaign.name}
              </div>
              <p className={styles.countHolder}>
                <p> {formatNumberAsThousands(campaign.count)}</p>
                {isClickable && (
                  <LinkNewTabIcon
                    className={styles.regainedGuestsListLinkIcon}
                    fill="#0079ff"
                    width={16}
                    height={16}
                  />
                )}
              </p>
            </div>
          ))}
      </div>
    </>
  )
}

export default SegmentsChart
